import { render, staticRenderFns } from "./PaginationNew.vue?vue&type=template&id=3cdd06ce&scoped=true&"
import script from "./PaginationNew.vue?vue&type=script&lang=js&"
export * from "./PaginationNew.vue?vue&type=script&lang=js&"
import style0 from "./PaginationNew.vue?vue&type=style&index=0&id=3cdd06ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdd06ce",
  null
  
)

export default component.exports